import { SEO } from "apps/commons/components/SEO";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";

export const HeadTag = () => {
    const { metaTitle, metaDescription } = usePartnerMarketingModelValue();

    return <SEO title={metaTitle} description={metaDescription} />;
};
